import useFetchData from 'app/hooks/useFetchData';
import { getCatalogListingApi } from 'app/services/showApi';
import { useCallback, useMemo } from 'react';

const CATALOG_LISTING_PAYLOAD = { park: '', inactive: 1 };
const CATALOG_CACHE_DURATION = 5 * 60 * 1000;

const normalizeCode = (value: any): string =>
  String(value ?? '')
    .trim()
    .toUpperCase();

export const useCatalogNameMap = () => {
  const { result, isLoading } = useFetchData<any>({
    actionApi: getCatalogListingApi,
    payloadData: CATALOG_LISTING_PAYLOAD,
    cacheDurationMs: CATALOG_CACHE_DURATION,
  });

  const catalogNameByCode = useMemo(() => {
    const catalogs: any[] = result?.data ?? [];
    return catalogs.reduce((acc: Record<string, string>, catalog) => {
      const name = catalog?.name ?? '';
      [catalog?.mapVGS, catalog?.id].forEach(key => {
        const normalized = normalizeCode(key);
        if (normalized) acc[normalized] = name;
      });
      return acc;
    }, {});
  }, [result]);

  const getCatalogName = useCallback(
    (code: string): string => catalogNameByCode[normalizeCode(code)] || code,
    [catalogNameByCode],
  );

  return { getCatalogName, isLoadingCatalog: isLoading };
};

export default useCatalogNameMap;
